<script setup>
import { inject, onMounted, watch } from "vue";
import { kebabCase } from "lodash";
import { TabsContent } from "reka-ui";
import { registerPanelInjectKey } from "~/components/base/Tabs/BaseTabs";

const props = defineProps({
  id: { type: String, required: false },
  name: { type: String, required: true },
  label: { type: String, default: null },
  /**
   * Use frame when you want to add a border around the content.
   */
  framed: { type: Boolean, default: false },
});

const registerPanel = inject(registerPanelInjectKey);
const id = props.id || kebabCase(props.name);

onMounted(() => {
  registerPanel({ id, name: props.name, label: props.label });
});

watch(
  () => props.name,
  (name) => {
    registerPanel({ id, name, label: props.label });
  }
);
watch(
  () => props.label,
  (label) => {
    registerPanel({ id, label, name: props.name });
  }
);
</script>

<template>
  <TabsContent :value="id">
    <div class="h-full" :class="[framed && 'rounded-md border p-4']">
      <slot />
    </div>
  </TabsContent>
</template>
